import "primeicons/primeicons.css";
import "../css/app.css";
import "./bootstrap";

import { createInertiaApp } from "@inertiajs/vue3";
import ui from "@nuxt/ui/vue-plugin";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createPinia } from "pinia";
import { createApp, h } from "vue";
import { ZiggyVue } from "ziggy-js";

import axios from "@/helpers/axios";

const appName = import.meta.env.VITE_APP_NAME || "PixelAI";

const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue"),
        ),
    setup({ el, App, props, plugin }) {
        let app = createApp({ render: () => h(App, props) });

        app.config.globalProperties.$axios = axios;

        pinia.use(({ store }) => {
            store.$axios = app.config.globalProperties.$axios;
        });

        app.use(plugin).use(ui).use(pinia).use(ZiggyVue).mount(el);

        return app;
    },
    progress: {
        color: "#4B5563",
    },
});
